/* eslint-disable @stencil-community/required-jsdoc */
import { Memoize, isEmpty, parseIfString } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop, getAssetPath } from '@stencil/core';

import type { FooterData } from './footer.types';
import type { EfbButton } from '../../atoms/button/button';
import state from '../../../store/store';

@Component({
  tag: 'efb-footer',
  styleUrl: 'footer.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class EfbFooter {
  /**
   * Props.
   */

  @Prop() data: FooterData | string;

  @Memoize('data')
  get parsedData(): FooterData {
    return parseIfString(this.data);
  }

  @Prop() socialLinks: EfbButton[] | string;

  @Memoize('socialLinks')
  get parsedSocialLinks(): EfbButton[] {
    return parseIfString(this.socialLinks);
  }

  @Prop() hasBackgroundVisual?: boolean;

  /**
   * Render
   */

  render() {
    const currentYear = new Date().getFullYear();

    return (
      <Host>
        <footer class={`footer ${this.hasBackgroundVisual && 'has-background-visual'}`}>
          <div class="content">
            {/* Ethi visual */}
            {this.hasBackgroundVisual && (
              <div class="ethi-visual">
                <picture>
                  <source
                    srcSet={`${getAssetPath('assets/ethis-jacky.webp')}, ${getAssetPath(
                      'assets/ethis-jacky@2x.webp'
                    )} 2x`}
                    type="image/webp"
                  />
                  <img
                    role="presentation"
                    class="img"
                    src={getAssetPath('assets/ethis-jacky.png')}
                    srcset={`${getAssetPath('assets/ethis-jacky@2x.png')} 2x`}
                    alt=""
                    width="480"
                    height="460"
                    loading="lazy"
                  />
                </picture>

                {/* Baseline */}
                <div
                  class="ethi-baseline"
                  innerHTML={
                    state.currentLanguage === 'nl'
                      ? 'Check onze <br /> packs, bruur.'
                      : 'Tema <br />nos packs !'
                  }
                ></div>
              </div>
            )}

            {/* Top */}
            <div class="top">
              {/* Left text */}
              <div class="text-wrapper">
                <efb-ethias-baseline />

                <efb-paragraph text={this.parsedData.text} size="sm" />

                <div class="button-wrapper">
                  <efb-button
                    {...this.parsedData.button}
                    target="_blank"
                    variant="purple-light"
                    ghost
                  />
                </div>
              </div>

              {/* Socials links */}
              {!isEmpty(this.parsedSocialLinks) && (
                <efb-social-links data={this.parsedSocialLinks} />
              )}
            </div>

            <hr class="dividing-line" />

            {/* Bottom */}
            <div class="bottom">
              <span>
                {this.parsedData.copyright} {currentYear}
              </span>

              {/* Legal links */}
              {!isEmpty(this.parsedData?.legalLinks) && (
                <nav>
                  <ul class="legal-links">
                    {/* Cookie settings */}
                    {/* <li class="legal-links-item">
                      <button data-action="gdpr-settings">Cookies</button>
                    </li> */}

                    {/* Other links */}
                    {this.parsedData.legalLinks.map((item) => (
                      <li class="legal-links-item">
                        <a href={item.link} target="_blank" data-analytics={item.dataAnalytics}>
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </footer>
      </Host>
    );
  }
}
